<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-terceiro')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-terceiro')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-form-item
          :label="$t('cliente')"
          prop="customer"
          v-if="userType !== '2' && userType !== '5'"
        >
          <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <CustomerList
              v-model="ruleForm.customer"
              v-bind:current="ruleForm.customer"
            />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('nome')" prop="name">
          <el-input ref="name" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('imagem')" prop="image">
          <el-upload
            class="avatar-uploader"
            action="/api/services/upload"
            accept="image/png, image/jpeg"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="changeFile"
          >
            <img v-if="ruleForm.content" :src="ruleForm.content" class="image-external" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { ExternalService } from "@/services/customers/external.services";
import { ServicesService } from "@/services/customers/services.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";

export default {
  name: "ExernalAdd",
  components: {
    CustomerList,
  },
  data() {
    return {
      id: "",
      userType: "2",
      ruleForm: {
        customer: "",
        name: "",
        content: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-obrigatorio"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({
        name: "external",
      });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ExternalService.get(vm.id)
        .then((response) => {
          vm.ruleForm.customer = response.customer;
          vm.ruleForm.name = response.name;
          vm.ruleForm.content = response.content;        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          ExternalService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("terceiro-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          ExternalService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("terceiro-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({ type: "error", message: error });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    changeFile(file) {
      var vm = this;
      ServicesService.upload(file)
        .then((response) => {
          vm.ruleForm.token = response.token;
          vm.ruleForm.content = response.content;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        if (vm.$route.params.id) {
          vm.id = vm.$route.params.id;
          vm.get();
        }
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>

<style>
.image-external {
  width: 100px;
  height: 60px
}
</style>